import { render } from "./ObjectCategoriesReadonly.vue?vue&type=template&id=61d935f0&scoped=true"
import script from "./ObjectCategoriesReadonly.vue?vue&type=script&lang=js"
export * from "./ObjectCategoriesReadonly.vue?vue&type=script&lang=js"

import "./ObjectCategoriesReadonly.vue?vue&type=style&index=0&id=61d935f0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d935f0"]])

export default __exports__